import { render } from "./ApprovementForm.vue?vue&type=template&id=211a11fa&scoped=true&ts=true"
import script from "./ApprovementForm.ts?vue&type=script&lang=ts"
export * from "./ApprovementForm.ts?vue&type=script&lang=ts"

import "./ApprovementForm.scss?vue&type=style&index=0&id=211a11fa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211a11fa"]])

export default __exports__